<script type="text/jsx">
/* eslint-disable vue/require-prop-types */
import UiRadioButton from 'ui/v1/controls/UiRadioButton';

export default {
    functional: true,
    model: {
        prop: 'selectedValue',
        event: 'selected',
    },
    props: ['name', 'label', 'value', 'selectedValue', 'changed'],

    render(h, { props, data, scopedSlots }) {
        const uniqueId = `${props.name}-${Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10)}`;

        const setValueChanged = () => {
            if (props.changed) {
                props.changed();
            }
        };

        const radioSelected = (value) => {
            setValueChanged();
            data.model.callback(value);
        };

        const radioOptionSelected = (e) => {
            if (e.target.getAttribute('class') && e.target.getAttribute('class').includes('multiselect')) {
                e.preventDefault();
            }
            setValueChanged();
            data.model.callback(props.value);
        };

        return <div { ...data } class="ui-rich-radio-option"
            aria-checked={ (props.value === props.selectedValue) }
            onClick={ radioOptionSelected }>
            <UiRadioButton class="radio-option pr-sm" onInput={ radioSelected }
                state={ props.selectedValue } id={ uniqueId } name={ props.name } value={ props.value }>
                <div class="radio-content" for={ uniqueId }>
                    <p class="font-semibold text-size-2">{ props.label }</p>
                    { scopedSlots.default && scopedSlots.default({ selectOption: () => radioOptionSelected }) }
                </div>
            </UiRadioButton>
        </div>;
    },
};
</script>
<style lang="scss" scoped>
.ui-rich-radio-option {
    @apply rounded border-2 border-gray bg-white p-sm cursor-pointer;

    &[aria-checked] {
        @apply border-azure bg-azure bg-opacity-8;
    }

    &.invalid {
        @apply border-error bg-white p-sm cursor-pointer;
    }
}
</style>
